import { createAuthAxios } from './auth';

const GROUP_CACHE_TTL = 30000;
const detailsCache = new Map();

const buildCacheKey = (accountId, inboxId, groupId) => {
  return `${accountId}:${inboxId}:${groupId}`;
};

const groupsService = {
  async details(accountId, inboxId, groupId, { force = false } = {}) {
    const cacheKey = buildCacheKey(accountId, inboxId, groupId);
    const cached = detailsCache.get(cacheKey);

    if (!force && cached && Date.now() - cached.timestamp < GROUP_CACHE_TTL) {
      return cached.data;
    }

    const http = createAuthAxios();
    const response = await http.get(
      `/api/v1/accounts/${accountId}/quepasa/${inboxId}/groups/details`,
      { params: { group_id: groupId } }
    );

    detailsCache.set(cacheKey, {
      timestamp: Date.now(),
      data: response.data,
    });

    return response.data;
  },

  async invite(accountId, inboxId, groupId) {
    const http = createAuthAxios();
    const response = await http.get(
      `/api/v1/accounts/${accountId}/quepasa/${inboxId}/groups/invite`,
      { params: { group_id: groupId } }
    );
    return response.data;
  },

  async updateParticipants(
    accountId,
    inboxId,
    groupId,
    participants,
    action = 'add'
  ) {
    const http = createAuthAxios();
    const response = await http.post(
      `/api/v1/accounts/${accountId}/quepasa/${inboxId}/groups/participants`,
      {
        group_id: groupId,
        participants,
        action,
      }
    );

    detailsCache.delete(buildCacheKey(accountId, inboxId, groupId));

    return response.data;
  },

  async importContacts(accountId, inboxId, groupId) {
    const http = createAuthAxios();
    const response = await http.post(
      `/api/v1/accounts/${accountId}/quepasa/${inboxId}/groups/import`,
      {
        group_id: groupId,
      }
    );

    return response.data;
  },

  clear(accountId, inboxId, groupId) {
    detailsCache.delete(buildCacheKey(accountId, inboxId, groupId));
  },
};

groupsService.details.help =
  'details(accountId, inboxId, groupId, { force }) - Fetches QuePasa group details and participants.';
groupsService.invite.help =
  'invite(accountId, inboxId, groupId) - Returns the public invite URL for a WhatsApp group.';
groupsService.updateParticipants.help =
  'updateParticipants(accountId, inboxId, groupId, participants, action) - Adds, removes, promotes or demotes group participants.';
groupsService.importContacts.help =
  'importContacts(accountId, inboxId, groupId) - Imports group participants as Hermes contacts linked to the selected inbox.';

export default groupsService;
